import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setAllFilter, setStarredFilter, setGroupFilter, setTalkgroupFilter } from "../features/callPlayer/callPlayerSlice";
import { useGetGroupsQuery, useGetFavoritesQuery } from "../features/api/apiSlice";
import DemoFilterPanel from "./DemoFilterPanel";

function DemoChips({ shortName }) {
  const dispatch = useDispatch();
  const { data: groupsData } = useGetGroupsQuery(shortName);
  const { data: favorites } = useGetFavoritesQuery(shortName);
  const filterType = useSelector((s) => s.callPlayer.filterType);
  const filterGroupId = useSelector((s) => s.callPlayer.filterGroupId);
  const filterStarred = useSelector((s) => s.callPlayer.filterStarred);
  const filterRows = useSelector((s) => s.callPlayer.filterRows);
  const [panelOpen, setPanelOpen] = useState(false);

  const allActive = filterType === 0 && !(filterRows && filterRows.length);
  const applyFav = (fav) => {
    if (fav.type === "group") dispatch(setGroupFilter(fav.groupId));
    else dispatch(setTalkgroupFilter(fav.talkgroups));
  };

  return (
    <div className="demo-chips">
      <button className={"demo-chip" + (allActive ? " active" : "")} onClick={() => dispatch(setAllFilter())}>All</button>
      <button className={"demo-chip" + (filterStarred ? " active" : "")}
        onClick={() => dispatch(setStarredFilter(!filterStarred))}>★ Starred</button>
      {(favorites || []).map((f) => (
        <button key={f._id} className="demo-chip" onClick={() => applyFav(f)}>☆ {f.label}</button>
      ))}
      {Array.isArray(groupsData) && groupsData.map((g) => (
        <button key={g._id}
          className={"demo-chip" + (filterType === 1 && filterGroupId === g._id ? " active" : "")}
          onClick={() => dispatch(setGroupFilter(g._id))}>
          {g.groupName}
        </button>
      ))}
      <button className="demo-chip demo-chip-more" onClick={() => setPanelOpen(true)}>Filter +</button>
      <DemoFilterPanel shortName={shortName} open={panelOpen} onClose={() => setPanelOpen(false)} />
    </div>
  );
}
export default DemoChips;
